import { shouldFilterFlareError } from "./flareErrorFilter";

type FlareClient = Pick<typeof import("@flareapp/js").flare, "configure">;
type FlareReport = import("@flareapp/js").Report;

let isFlareClientConfigured = false;

const browserEventFilterOptions = {
  filterExpectedRequestErrors: true,
  filterTransientBrowserErrors: true,
};

/**
 * Configure the singleton Flare SDK once. The SDK registers global browser
 * listeners at module import time, so these hooks are the canonical filter path
 * for SDK-reported errors and message-only reports.
 */
export function configureFlareClient(flare: FlareClient): void {
  if (isFlareClientConfigured) {
    return;
  }

  flare.configure({
    stage: process.env.NODE_ENV,
    version: process.env.NEXT_PUBLIC_APP_VERSION,
    beforeEvaluate: (error: Error) => {
      if (shouldFilterFlareError(error, undefined, browserEventFilterOptions)) {
        return false;
      }

      return error;
    },
    beforeSubmit: (report: FlareReport) => {
      if (
        shouldFilterFlareError(
          null,
          report.message ?? undefined,
          browserEventFilterOptions,
        )
      ) {
        return false;
      }

      return report;
    },
  });

  isFlareClientConfigured = true;
}
